(() => {
  const legacyPanel = /size chart|printed\s*&\s*shipped|try then decide guarantee|benefit call out|^product info$/i;
  const legacyPanelFile = /size[_-]?chart|printed[_-]?shipped|try[_-]?then[_-]?decide[_-]?guarantee|benefit[_-]?call[_-]?out|hollow[_-]?product[_-]?images/i;
  const modelPhoto = /modeled lifestyle|generated model photo/i;
  const photoAlt = (slide) => slide.querySelector('img.image-magnify-none')?.alt || slide.querySelector('.product__modal-opener img')?.alt || '';
  // V14: products whose photos carry "[bb c=<colour> r=<role>]" in their alt text get a colour-only gallery,
  // a model line under the gallery and a size line under the size buttons. Untagged products are unchanged.
  const bbTag = (slide) => { const m = photoAlt(slide).match(/\[bb c=([a-z0-9-]+) r=([a-z0-9]+)\]/); return m ? { c: m[1], r: m[2] } : null; };
  const ROLE_ORDER = ['hero', 'fit', 'close', 'body2', 'friends', 'flat'];
  const LINE = /([A-Z][a-z]+ is \d′\d{1,2}″ and wears her usual size [0-9]*X*[SML]\.|Friends are wearing [^.\[]+\.)/;
  const slug = (value) => (value || '').toLowerCase().trim().replace(/\s+/g, '-');
  // Chest width laid flat x2, body length (inches); usual women's size it suits
  const FIT = { XS: [32, 27, 'XS (0–2)'], S: [36, 28, 'S (4–6)'], M: [40, 29, 'M (8–10)'], L: [44, 30, 'L (12–14)'], XL: [48, 31, 'XL (16)'], '2XL': [52, 32, '2XL (18–20)'], '3XL': [56, 33, '3XL (22–24)'] };
  const photoSrc = (slide) => slide.querySelector('img.image-magnify-none')?.currentSrc || slide.querySelector('img.image-magnify-none')?.src || '';

  function arrange(gallery, selectedColor) {
    gallery.bbBwaColourNow = selectedColor || '';
    if (!gallery?.querySelector('.bb-editorial-slide')) return;
    const viewer = gallery.querySelector('.product__media-list');
    const thumbs = gallery.querySelector('.thumbnail-list');
    if (!viewer) return;

    for (const slide of [...viewer.querySelectorAll(':scope > li[data-media-id]')]) {
      if (slide.classList.contains('bb-editorial-slide')) continue;
      const alt = photoAlt(slide);
      if (!legacyPanel.test(alt) && !legacyPanelFile.test(photoSrc(slide))) continue;
      thumbs?.querySelector(`[data-target="${slide.dataset.mediaId}"]`)?.remove();
      slide.remove();
    }

    const slides = [...viewer.querySelectorAll(':scope > li[data-media-id]')];
    const photos = slides.filter((slide) => !slide.classList.contains('bb-editorial-slide') && !slide.classList.contains('bb-bwa-slide'));
    if (photos.some(bbTag)) return arrangeTagged(gallery, viewer, thumbs, photos, selectedColor);
    const primary = photos.find((slide) => slide.classList.contains('is-active')) || photos[0];
    const color = (selectedColor || '').toLowerCase();
    const matchingModel = photos.find((slide) => slide !== primary && modelPhoto.test(photoAlt(slide)) && (!color || photoAlt(slide).toLowerCase().includes(color)));
    const otherModels = photos.filter((slide) => slide !== primary && slide !== matchingModel && modelPhoto.test(photoAlt(slide)));
    for (const slide of photos) {
      const hide = false;
      slide.classList.toggle('bb-gallery-color-hidden', hide);
      const thumb = thumbs?.querySelector(`[data-target="${slide.dataset.mediaId}"]`);
      thumb?.classList.toggle('bb-gallery-color-hidden', hide);
    }
    const byRole = (role) => viewer.querySelector(`[data-bb-role="${role}"]`);
    const ordered = bwaOrder(gallery, viewer, [primary, matchingModel, ...otherModels, ...photos.filter((slide) => slide !== primary && slide !== matchingModel && !otherModels.includes(slide))].filter(Boolean)).concat([byRole('community'), byRole('why'), byRole('origin'), byRole('guarantee'), byRole('size')]).filter(Boolean);

    for (const slide of ordered) {
      viewer.appendChild(slide);
      const thumb = thumbs?.querySelector(`[data-target="${slide.dataset.mediaId}"]`);
      if (thumb) thumbs.appendChild(thumb);
    }
    if (thumbs) [...thumbs.querySelectorAll('[data-target]')].filter((thumb) => thumb.getClientRects().length).forEach((thumb, index) => { thumb.dataset.mediaPosition = String(index + 1); });
    gallery.querySelector('[id^="GalleryViewer"]')?.resetPages?.();
    gallery.querySelector('[id^="GalleryThumbnails"]')?.resetPages?.();
    markFirstActive(gallery, viewer, thumbs);
    const total = gallery.querySelector('.slider-counter--total');
    if (total) {
      gallery.bbEditorialSlideCount = thumbs
        ? [...thumbs.querySelectorAll('[data-target]')].filter((thumb) => thumb.getClientRects().length).length
        : ordered.filter((slide) => !slide.classList.contains('bb-gallery-color-hidden')).length;
      total.textContent = String(gallery.bbEditorialSlideCount);
      if (!gallery.bbTotalObserver) {
        gallery.bbTotalObserver = new MutationObserver(() => {
          const expected = String(gallery.bbEditorialSlideCount);
          if (total.textContent !== expected) total.textContent = expected;
        });
        gallery.bbTotalObserver.observe(total, { childList: true, characterData: true, subtree: true });
      }
    }
  }


  // Better With Age preview: seasonal photos (.bb-bwa-slide). On first load slide 1 leads;
  // after a colour change the colour photo leads. Slides 2-3 follow the first colour photo, 4 (print close-up) goes last.
  function bwaOrder(gallery, viewer, colourPhotos) {
    const bwa = (n) => viewer.querySelector(`.bb-bwa-slide[data-bwa-pos="${n}"]`);
    if (!bwa(1)) return colourPhotos;
    const [first, ...rest] = colourPhotos;
    const colour = slug(gallery.bbBwaColourNow);
    if (gallery.bbBwaFirstColour === undefined) gallery.bbBwaFirstColour = colour;
    const lead = colour !== gallery.bbBwaFirstColour ? [first, bwa(1)] : [bwa(1), first];
    return [...lead, bwa(2), bwa(3), ...rest, bwa(4)].filter(Boolean);
  }

  function markFirstActive(gallery, viewer, thumbs) {
    const first = [...viewer.querySelectorAll(':scope > li[data-media-id]')].find((slide) => !slide.classList.contains('bb-gallery-color-hidden'));
    if (!first || !viewer.querySelector('.bb-bwa-slide')) return;
    viewer.querySelectorAll(':scope > li.is-active').forEach((slide) => slide.classList.remove('is-active'));
    first.classList.add('is-active');
    thumbs?.querySelectorAll('button[aria-current]').forEach((button) => button.removeAttribute('aria-current'));
    thumbs?.querySelector(`[data-target="${first.dataset.mediaId}"] button`)?.setAttribute('aria-current', 'true');
  }

  function arrangeTagged(gallery, viewer, thumbs, photos, selectedColor) {
    const want = slug(selectedColor) || bbTag(photos.find(bbTag)).c;
    const visible = [];
    for (const slide of photos) {
      const t = bbTag(slide);
      const hide = !t || (t.c !== 'all' && t.c !== want);
      slide.classList.toggle('bb-gallery-color-hidden', hide);
      thumbs?.querySelector(`[data-target="${slide.dataset.mediaId}"]`)?.classList.toggle('bb-gallery-color-hidden', hide);
      if (!hide) visible.push(slide);
    }
    visible.sort((a, b) => ROLE_ORDER.indexOf(bbTag(a).r) - ROLE_ORDER.indexOf(bbTag(b).r));
    const byRole = (role) => viewer.querySelector(`[data-bb-role="${role}"]`);
    const hidden = photos.filter((slide) => !visible.includes(slide));
    const ordered = [...bwaOrder(gallery, viewer, visible), byRole('community'), byRole('why'), byRole('origin'), byRole('guarantee'), byRole('size'), ...hidden].filter(Boolean);
    for (const slide of ordered) {
      viewer.appendChild(slide);
      const thumb = thumbs?.querySelector(`[data-target="${slide.dataset.mediaId}"]`);
      if (thumb) thumbs.appendChild(thumb);
    }
    if (thumbs) [...thumbs.querySelectorAll('[data-target]')].filter((thumb) => thumb.getClientRects().length).forEach((thumb, index) => { thumb.dataset.mediaPosition = String(index + 1); });
    gallery.querySelector('[id^="GalleryViewer"]')?.resetPages?.();
    gallery.querySelector('[id^="GalleryThumbnails"]')?.resetPages?.();
    viewer.scrollTo?.({ left: 0 });
    markFirstActive(gallery, viewer, thumbs);
    const total = gallery.querySelector('.slider-counter--total');
    if (total) {
      gallery.bbEditorialSlideCount = ordered.filter((slide) => !slide.classList.contains('bb-gallery-color-hidden')).length;
      total.textContent = String(gallery.bbEditorialSlideCount);
      if (!gallery.bbTotalObserver) {
        gallery.bbTotalObserver = new MutationObserver(() => {
          const expected = String(gallery.bbEditorialSlideCount);
          if (total.textContent !== expected) total.textContent = expected;
        });
        gallery.bbTotalObserver.observe(total, { childList: true, characterData: true, subtree: true });
      }
    }
    setupModelLine(gallery, viewer);
    // size line removed 2026-09-30 (Andrew: confusing); setupSizeLine kept for later
  }

  function currentSlide(viewer) {
    const shown = [...viewer.querySelectorAll(':scope > li[data-media-id]')].filter((slide) => !slide.classList.contains('bb-gallery-color-hidden'));
    if (viewer.scrollWidth > viewer.clientWidth + 4) {
      const left = viewer.getBoundingClientRect().left;
      return shown.reduce((best, slide) => (Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(best.getBoundingClientRect().left - left) ? slide : best), shown[0]);
    }
    return shown.find((slide) => slide.classList.contains('is-active')) || shown[0];
  }

  function setupModelLine(gallery, viewer) {
    let line = gallery.bbModelLine;
    if (!line) {
      line = document.createElement('p');
      line.className = 'bb-model-line is-off';
      line.setAttribute('aria-live', 'polite');
      gallery.insertAdjacentElement('afterend', line);
      gallery.bbModelLine = line;
      let frame = 0;
      viewer.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, { passive: true });
      gallery.addEventListener('click', () => setTimeout(update, 350));
    }
    function update() {
      const slide = currentSlide(viewer);
      const match = slide && bbTag(slide) && photoAlt(slide).match(LINE);
      line.textContent = match ? match[1] : '';
      line.classList.toggle('is-off', !match);
    }
    gallery.bbUpdateModelLine = update;
    update();
  }

  function setupSizeLine(gallery) {
    const section = gallery.closest('section, .product') || document;
    const input = section.querySelector('input[name="Size"]') || document.querySelector('variant-radios input[name="Size"]');
    const fieldset = input?.closest('fieldset');
    if (!fieldset || fieldset.bbSizeLine) return;
    const line = document.createElement('p');
    line.className = 'bb-size-line';
    fieldset.insertAdjacentElement('afterend', line);
    fieldset.bbSizeLine = line;
    const update = () => {
      const size = fieldset.querySelector('input[name="Size"]:checked')?.value || '';
      const fit = FIT[size];
      line.hidden = !fit;
      if (fit) line.innerHTML = `<strong>${size}: ${fit[0]}″ around the chest, ${fit[1]}″ long.</strong><span>Relaxed on a women's ${fit[2]}.</span>`;
    };
    fieldset.addEventListener('change', update);
    update();
  }

  window.bbArrangeProductGallery = arrange;
  document.addEventListener('DOMContentLoaded', () => {
    const color = document.querySelector('variant-radios input[name="Color"]:checked')?.value || '';
    document.querySelectorAll('media-gallery').forEach((gallery) => arrange(gallery, color));
  });
})();
